(function () {
    'use strict';

    angular
        .module('riskModule')
        .directive('selectDepartmentRisk', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                modalTitle: '@',
                whenSelectedRisk: '&'
            },
            controller: ['$scope', '$modal', '$timeout', function ($scope, $modal, $timeout) {

                $timeout(function () {
                    var searchField = document.querySelector('[autofocus]');
                    if (searchField && searchField.focus && typeof searchField.focus === 'function') {
                        searchField.focus();
                    }
                }, 0);

                $scope.selectRisk = function () {

                    // Modal to select risk
                    var modalScope = $scope.$new(true);
                    modalScope.modalTitle = $scope.modalTitle;
                    modalScope.actualRisks = $scope.risks;

                    var selectRiskModal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/risk/selectDepartmentRiskModal.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        selectRiskModal.$promise.then(selectRiskModal.hide);
                    }

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    }

                    // Add the selected risk
                    modalScope.whenSelectRisk = function (selectedRisk) {
                        $scope.whenSelectedRisk({ risk: selectedRisk });
                        modalScope.okModal();
                    }
                };
            }],
            link: function (scope, elem, attrs) {

                elem.bind('click', function () {
                    scope.selectRisk();
                });
            }
        }
    }
})();